import axios from 'axios';
import { EmailFields, getEmlFileMetaData, getMsgFileMetaData } from 'components/MsgReader';
import ImportedFileTag from 'components/new-order-entry/Documents/ImportedFileTag';
import TextField from 'components/ui/TextField';
import produce from 'immer';
import { convertToBase64, getCurrentDateTimeForDateTimePicker } from 'lib/PublicFunctions';
import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import AsyncSelect from 'react-select/async';
import PropertiesAndSearchesContin from './PropertiesAndSearchesContin';
import { customStyles, DocumentOptions, UploadButton } from './styles';
import {
  AddedSearches,
  FileUpload,
  OrderDetails,
  SearchTypeObject,
  FrontMessage,
  ContactOption,
  SearchToAdd,
} from './types';
import { uniqBy } from 'lodash';
import { Checkbox } from 'semantic-ui-react';
import Button from 'components/ui/Button';
import convertToFileDownload from 'components/FileDownloads';
import ConfirmActionModal from 'components/ui/ConfirmActionModal';
import RulesIcon from 'components/orders/order-information/RulesIcon';
import { Multiselect } from 'react-widgets';
import { BulkSearchesInfo } from './BulkSearchesInfo';
import { SearchInfoBySearchType } from './SearchInfoBySearchType';
import { toast } from 'react-toastify';
import SendGridErrorModal from 'components/ui/SendGridErrorModal';
import {
  buildContinEmailBody,
  buildContinEmailContactOptions,
  buildContinEmailSubjectDefault,
  getVendorEmail,
  hasVendorEmail,
} from './continEmailDefaults';

type ClientType = 'Accutitle' | 'Riverside' | '';
type SearchTypeObjectForSubmit = Omit<SearchTypeObject, 'emailInfo' | 'vendorEmailAttachments'> & {
  emailInfo: SearchTypeObject['emailInfo'] & { emailBody: string };
  vendorEmailAttachments?: FileUpload[];
};
type EffectiveSearchTypeState = {
  assigneeId?: number;
  assigneeIsEmployee: boolean;
  hasVendorAssignee: boolean;
  dueBy: string;
  isPriority: boolean;
  requestNotes: string;
  emailBody: string;
  vendorAttachments: FileUpload[];
};

export default function UploadContin() {
  const [orderDetails, setOrderDetails] = useState<OrderDetails>({
    id: null,
    titleNumber: '',
    clientId: null,
    integrationType: null,
  });
  const [properties, setProperties] = useState<any[]>([]);
  const [allSearchesOfOrder, setAllSearchesOfOrder] = useState([]);
  const [files, setFiles] = useState<FileUpload[]>([]);
  const [msgData, setMsgData] = useState<EmailFields>();
  const [continReceiver, setContinReceiver] = useState('');
  const [uniqueSearchesOfOrder, setUniqueSearchesOfOrder] = useState([]);
  const [assignees, setAssignees] = useState([]);
  const [propertyId, setPropertyId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [savePopup, setSavePopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [clientType, setClientType] = useState<ClientType>('');
  const [abstractDefaultAssignee, setAbstractDefaultAssignee] = useState(null);
  const [showConflictingAbstractAssigneesModal, setShowConflictingAbstractAssigneesModal] = useState(false);
  const [conflictingAbstractAssigneesString, setConflictingAbstractAssigneesString] = useState<string>(null);
  const [selectedAssignOnlySearchCodes, setSelectedAssignOnlySearchCodes] = useState<string[]>([]);
  const [orderSearchResults, setOrderSearchResults] = useState<any[]>([]);
  const [sentFromEmail, setSentFromEmail] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [frontMessageId, setFrontMessageId] = useState('');
  const [fetchingFrontFile, setFetchingFrontFile] = useState(false);
  const [ccReceivers, setCcReceivers] = useState([]);
  const [assignInBulk, setAssignInBulk] = useState(true);
  const [bulkDueBy, setBulkDueBy] = useState<string>(null);
  const [bulkAssignTo, setBulkAssignTo] = useState(null);
  const [bulkAbstractAssignTo, setBulkAbstractAssignTo] = useState(null);
  const [bulkAdditionalSendEmails, setBulkAdditionalSendEmails] = useState<number[]>([]);
  const [bulkIsPriority, setBulkIsPriority] = useState(false);
  const [bulkIsSixMonthContin, setBulkIsSixMonthContin] = useState(false);
  const [bulkRequestNotes, setBulkRequestNotes] = useState('');
  const [bulkVendorEmailAttachments, setBulkVendorEmailAttachments] = useState<FileUpload[]>([]);
  const [searchTypeObjects, setSearchTypeObjects] = useState<SearchTypeObject[]>([]);
  const [bulkSelectedContacts, setBulkSelectedContacts] = useState<ContactOption[]>([]);
  const [bulkSelectedCcEmails, setBulkSelectedCcEmails] = useState<ContactOption[]>([]);
  const [bulkSelectedBccEmails, setBulkSelectedBccEmails] = useState<ContactOption[]>([]);
  const [bulkSubject, setBulkSubject] = useState('');
  const vendorEmailRequestsRef = React.useRef<Record<number, boolean>>({});
  const [scheduleSendMin, setScheduleSendMin] = useState('');
  const [bulkScheduleSend, setBulkScheduleSend] = useState(false);
  const [bulkScheduleSendDateTime, setBulkScheduleSendDateTime] = useState('');
  const [sendGridError, setSendGridError] = useState(false);
  const [bulkSendEmail, setBulkSendEmail] = useState(true);
  const [vendorEmailsById, setVendorEmailsById] = useState<Record<number, string>>({});
  const isSearchSelected = allSearchesOfOrder.some(s => s.selected);
  const isAbstractSearchSelected = allSearchesOfOrder.some(s => s.selected && s.searchCategory == 'Abstract');
  const selectedAssignOnlySearches = allSearchesOfOrder.filter(s => s.selected && !s.canCreateContin);
  const bulkEmailFieldsVisible = bulkAbstractAssignTo?.vendorId > 0 || bulkAssignTo?.vendorId > 0;
  const bulkVendorId = React.useMemo(
    () =>
      bulkAbstractAssignTo?.vendorId > 0
        ? bulkAbstractAssignTo.vendorId
        : bulkAssignTo?.vendorId > 0
        ? bulkAssignTo.vendorId
        : null,
    [bulkAbstractAssignTo, bulkAssignTo]
  );
  const bulkMunicipality = properties[0]?.subMunicipality ?? properties[0]?.municipality;
  const bulkDefaultSubject = React.useMemo(
    () =>
      orderDetails.titleNumber
        ? buildContinEmailSubjectDefault({
            titleNumber: orderDetails.titleNumber,
            isAbstract: isAbstractSearchSelected,
            municipality: bulkMunicipality,
          })
        : '',
    [orderDetails.titleNumber, isAbstractSearchSelected, bulkMunicipality]
  );
  const bulkVendorEmail = React.useMemo(() => getVendorEmail(vendorEmailsById, bulkVendorId), [
    bulkVendorId,
    vendorEmailsById,
  ]);
  const bulkDefaultContacts = React.useMemo(() => buildContinEmailContactOptions(bulkVendorEmail), [
    bulkVendorId,
    bulkVendorEmail,
  ]);
  const cloneFileUploads = React.useCallback(
    (attachments: FileUpload[] = []) => attachments.map(attachment => ({ ...attachment })),
    []
  );

  const getSubjectMunicipality = (searchesToAdd: SearchToAdd[]) => {
    const property = properties.find(p => searchesToAdd.some(search => search.propertyId === p.id));
    return property?.subMunicipality ?? property?.municipality ?? '';
  };

  const getDefaultSubjectForSearchType = (isAbstract: boolean, searchesToAdd: SearchToAdd[]) =>
    orderDetails.titleNumber
      ? buildContinEmailSubjectDefault({
          titleNumber: orderDetails.titleNumber,
          isAbstract,
          municipality: getSubjectMunicipality(searchesToAdd),
        })
      : '';

  const hasBulkVendorAssigneeForSearchType = (isAbstract: boolean) =>
    isAbstract ? bulkAbstractAssignTo?.vendorId > 0 : bulkAssignTo?.vendorId > 0;

  const createSearchTypeObject = ({
    searchTypeId,
    searchCode,
    searchesToAdd,
    isAbstract,
    hasVendor,
  }: {
    searchTypeId: number;
    searchCode: string;
    searchesToAdd: SearchToAdd[];
    isAbstract: boolean;
    hasVendor: boolean;
  }): SearchTypeObject => ({
    searchTypeId,
    searchCode,
    searchesToAdd,
    isAbstract,
    emailInfo: {
      toAddresses: [],
      ccAddresses: [],
      bccAddresses: [],
      subject: getDefaultSubjectForSearchType(isAbstract, searchesToAdd),
      scheduleSend: false,
    },
    showEmailFields: hasVendor,
    sendEmail: hasVendor,
  });

  const fetchVendorEmail = React.useCallback(async (vendorId: number) => {
    if (!vendorId || vendorEmailRequestsRef.current[vendorId]) {
      return;
    }

    vendorEmailRequestsRef.current[vendorId] = true;
    try {
      const { data } = await axios.get(`/api/contins/getVendorEmail/${vendorId}`);
      setVendorEmailsById(current => ({ ...current, [vendorId]: data ?? '' }));
    } finally {
      delete vendorEmailRequestsRef.current[vendorId];
    }
  }, []);

  useEffect(() => {
    if (orderDetails?.id) {
      getAccutitleInfo();
      getRiversideOrderInfo();
    }
  }, [orderDetails]);

  useEffect(() => {
    if (isAbstractSearchSelected) {
      const abstractSearches = allSearchesOfOrder.filter(s => s.selected && s.searchCategory == 'Abstract');
      if (abstractSearches.length >= 1) {
        var abstractSearchAssignees = {};
        var categoryIndex = 1;
        var assigneeObject = {};
        abstractSearches.forEach(element => {
          var assigneeHistory = element.searchHistories.find(
            (s: any) => s.searchStatusType == 'Requested' && s.assignedTo
          );
          if (assigneeHistory) {
            categoryIndex = 1;
            assigneeObject = {
              displayName: element.displayName,
              propertyAddress: properties.find(p => p.id == element.propertyId)?.address,
            };
            const assignedTo =
              assigneeHistory.assignedTo == 'Moody Eagle Abstracts LLC'
                ? 'Ryco Information Services, Inc.'
                : assigneeHistory.assignedTo;
            if ((abstractSearchAssignees as any)[assignedTo]) {
              (abstractSearchAssignees as any)[assignedTo].push(assigneeObject);
            } else {
              (abstractSearchAssignees as any)[assignedTo] = new Array(assigneeObject);
            }
          } else {
            assigneeHistory = element.searchHistories.find(
              (s: any) => s.searchStatusType == 'In Progress' && s.assignedTo
            );
            if (assigneeHistory) {
              categoryIndex = 1;
              assigneeObject = {
                displayName: element.displayName,
                propertyAddress: properties.find(p => p.id == element.propertyId)?.address,
              };
              if ((abstractSearchAssignees as any)[assigneeHistory.assignedTo]) {
                (abstractSearchAssignees as any)[assigneeHistory.assignedTo].push(assigneeObject);
              } else {
                (abstractSearchAssignees as any)[assigneeHistory.assignedTo] = new Array(assigneeObject);
              }
            }
          }
        });
        const distinctAssignees = Object.keys(abstractSearchAssignees);
        if (distinctAssignees.length == 1) {
          const defaultAssignee = assignees[categoryIndex].items.find(
            (a: any) => a.name == distinctAssignees[0]
          );
          if (defaultAssignee) {
            const fieldNameForObject = categoryIndex === 0 ? 'employeeId' : 'vendorId';
            setAbstractDefaultAssignee({ ...defaultAssignee, categoryIndex });
            setBulkAbstractAssignTo({
              ...defaultAssignee,
              categoryIndex,
              [fieldNameForObject]: defaultAssignee?.id,
            });
            if (categoryIndex === 1) {
              const newSearchTypeObjects = produce(searchTypeObjects, draft => {
                const searchTypeObjects = draft.filter(s => s.isAbstract);
                searchTypeObjects.forEach(s => {
                  s.showEmailFields = true;
                  s.sendEmail = true;
                });
              });
              setSearchTypeObjects(newSearchTypeObjects);
            }
          }
        } else if (distinctAssignees.length > 1) {
          const conflictingAbstractAssigneesString = createModalString(abstractSearchAssignees);
          setConflictingAbstractAssigneesString(conflictingAbstractAssigneesString);
          setShowConflictingAbstractAssigneesModal(true);
          setAbstractDefaultAssignee(null);
          setBulkAbstractAssignTo(null);
        }
      }
    } else {
      setAbstractDefaultAssignee(null);
      setBulkAbstractAssignTo(null);
    }
  }, [allSearchesOfOrder]);

  useEffect(() => {
    const searchCodesUnique = new Set(selectedAssignOnlySearches.map(s => s.searchCode));
    setSelectedAssignOnlySearchCodes(Array.from(searchCodesUnique));
  }, [selectedAssignOnlySearches.length]);

  useEffect(() => {
    if (orderDetails.clientId) {
      setContinReceiver(getDefaultReceiver(orderDetails.clientId, sentFromEmail));
    }
  }, [sentFromEmail, orderDetails.clientId]);

  useEffect(() => {
    if (assignInBulk && bulkEmailFieldsVisible && bulkDefaultSubject) {
      setBulkSubject(bulkDefaultSubject);
    }
  }, [assignInBulk, bulkDefaultSubject, bulkEmailFieldsVisible]);

  useEffect(() => {
    if (bulkVendorId && !hasVendorEmail(vendorEmailsById, bulkVendorId)) {
      fetchVendorEmail(bulkVendorId);
    }
  }, [bulkVendorId, vendorEmailsById, fetchVendorEmail]);

  useEffect(() => {
    setBulkSelectedContacts(bulkDefaultContacts);
  }, [bulkDefaultContacts]);

  const applyBulkVendorEmailAttachments = React.useCallback(
    (attachments: FileUpload[]) => setBulkVendorEmailAttachments(cloneFileUploads(attachments)),
    [cloneFileUploads]
  );

  const createModalString = (abstractSearchAssignees: {}) => {
    var modalString = '';
    Object.keys(abstractSearchAssignees).forEach(element => {
      modalString += `${element}: \n`;
      (abstractSearchAssignees as any)[element].forEach((item: any) => {
        modalString += ` - ${item.displayName} (${item.propertyAddress}) \n`;
      });
      modalString += '\n';
    });
    return modalString;
  };

  const handleModalClose = () => {
    setShowConflictingAbstractAssigneesModal(false);
  };

  const onSelectOrder = (e: any) => {
    if (e) {
      setOrderDetails(e);
      setContinReceiver(getDefaultReceiver(e.clientId, sentFromEmail));
    }
  };

  const onPasteFrontMessageId = async (frontMessageId: string) => {
    const { data } = await axios.get<FrontMessage>(`/api/front/GetMessageInfoForFrontId/${frontMessageId}`);
    setFrontMessageId(frontMessageId);
    var from = data.recipients.find(r => r.role === 'from');
    var messageData: EmailFields = {
      subject: data.subject,
      senderEmail: from?.handle || '',
      ccEmails: data.recipients.filter(r => r.role === 'cc').map(r => r.handle),
    };
    parseMsgFile(messageData);
    setMsgData(messageData);
    getFrontMessageAsFile(frontMessageId);
  };

  const getFrontMessageAsFile = (frontMessageId: string) => {
    setFetchingFrontFile(true);
    axios
      .get<string>(`/api/front/GetPdfForMessageId/${frontMessageId}`)
      .then(({ data }) => {
        var newFiles = produce(files, draft => {
          draft.push({ file: data, actualFileName: `FrontMessage_${frontMessageId}.pdf` });
        });
        setFiles(newFiles);
      })
      .finally(() => {
        setFetchingFrontFile(false);
      });
  };

  const onDrop = async (newFiles: any) => {
    const arr: FileUpload[] = [];
    for (let file of newFiles) {
      const base64 = (await convertToBase64(file)) as string;
      const tempFile: FileUpload = {
        file: base64,
        actualFileName: file.name,
      };
      const extension = file?.name?.substring(file?.name?.lastIndexOf('.'));

      arr.push(tempFile);
    }

    const newArray = produce(files, draft => {
      for (let file of arr) {
        draft.push(file);
      }
    });
    setFiles(newArray);
    const extension = newFiles[0]?.name?.substring(newFiles[0]?.name?.lastIndexOf('.'));
    const msgData =
      extension == '.eml' ? await getEmlFileMetaData(newFiles[0]) : await getMsgFileMetaData(newFiles[0]);
    parseMsgFile(msgData);
    setMsgData(msgData);
  };

  const reactivateProperty = async (propertyId: number) => {
    const { data, status } = await axios.post(`/api/property/reactivateProperty/${propertyId}`);
    if (status === 200) {
      const newProperties = produce(properties, draft => {
        const index = draft.findIndex(p => p.id === propertyId);
        draft[index].deactivated = false;
      });
      setProperties(newProperties);
    }
  };

  const onRemoveFileClick = (index: any) => {
    setFiles(files.filter((f: any, i: any) => i !== index));
    setSentFromEmail('');
    setCcReceivers([]);
  };
  const changeCustomFileName = (index: number) => (newName: string) => {
    const newFiles = produce(files, draft => {
      const fileName = draft[index].actualFileName;
      const extension = fileName.substring(fileName.lastIndexOf('.'));
      var startExtension = newName.lastIndexOf('.');
      const newExtension = newName.substring(startExtension);
      const removedExtensionFromName = startExtension > -1 ? newName.substring(0, startExtension) : newName;
      draft[index].actualFileName = `${removedExtensionFromName}${
        startExtension === -1 || newExtension.length > 5 ? extension : newExtension
      }`;
    });
    setFiles(newFiles);
  };
  const getSearchesOfOrder = async () => {
    const [{ data: allSearches }, { data: properties }, { data: accutitleInfo }, { data: riversideInfo }] =
      await Promise.all([
        axios.get(`/api/orders/getOrderSearches/${orderDetails.id}`),
        axios.get(`/api/orders/getOrderProperties/${orderDetails.id}`),
        axios.get(`/api/orders/getaccutitleInfo/${orderDetails.id}`),
        axios.get(`/api/orders/getriversideorderinfo/${orderDetails.id}`),
      ]);
    const completedSearches = allSearches?.filter((cs: any) => cs.searchStatusType === 'Completed');
    const latestSearchByTypeAndProperty = new Map<string, any>();
    const accutitleNumberBySearchId = new Map(
      (accutitleInfo?.searchInfo ?? []).map((search: any) => [search.id, search.value])
    );
    const riversideSearchIdBySearchId = new Map(
      (riversideInfo?.searchInfo ?? []).map((search: any) => [search.id, search.value])
    );

    allSearches.forEach((search: any) => {
      const key = `${search.searchTypeId}-${search.propertyId}`;
      const existing = latestSearchByTypeAndProperty.get(key);
      if (!existing || search.id > existing.id) {
        latestSearchByTypeAndProperty.set(key, search);
      }
    });

    const getCurrentIntegrationIds = (search: any) => {
      const latestSearch =
        latestSearchByTypeAndProperty.get(`${search.searchTypeId}-${search.propertyId}`) ?? search;
      return {
        accutitleNumber:
          accutitleNumberBySearchId.get(latestSearch.id) ??
          latestSearch.accutitleNumber ??
          search.accutitleNumber ??
          null,
        riversideSearchId:
          riversideSearchIdBySearchId.get(latestSearch.id) ??
          latestSearch.riversideSearchId ??
          search.riversideSearchId ??
          null,
      };
    };

    const propertiesWithSearches = properties.map((p: any) => {
      const searches = completedSearches.filter((s: any) => {
        return s.propertyId === p.id;
      });
      return {
        ...p,
        searches: searches.map((s: any) => {
          const searchesOfType = allSearches.filter(
            (all: any) => all.searchTypeId === s.searchTypeId && all.propertyId === s.propertyId
          );
          const canCreateContin = searchesOfType.every((search: any) =>
            [6, 8].includes(search.searchStatusId)
          );
          const integrationIds = getCurrentIntegrationIds(s);
          return {
            ...s,
            ...integrationIds,
            canCreateContin,
            assignedTo: searchesOfType.find((search: any) => search.assignedTo)?.assignedTo || null,
            currentStatus: canCreateContin
              ? null
              : searchesOfType.find((search: any) => ![6, 8].includes(search.searchStatusId))
                  ?.searchStatusType || null,
          };
        }),
      };
    });
    setProperties(propertiesWithSearches);
    setAllSearchesOfOrder(
      completedSearches.map((cs: any) => {
        const canCreateContin = allSearches
          .filter((all: any) => all.searchTypeId === cs.searchTypeId && all.propertyId === cs.propertyId)
          .every((search: any) => [6, 8].includes(search.searchStatusId));
        const integrationIds = getCurrentIntegrationIds(cs);
        return {
          ...cs,
          selected: false,
          ...integrationIds,
          canCreateContin,
          assignedTo:
            allSearches.find(
              (s: any) => s.searchTypeId === cs.searchTypeId && s.propertyId === cs.propertyId && s.assignedTo
            )?.assignedTo || null,
          currentStatus: canCreateContin
            ? null
            : allSearches.find(
                (s: any) =>
                  s.searchTypeId === cs.searchTypeId &&
                  s.propertyId === cs.propertyId &&
                  ![6, 8].includes(s.searchStatusId)
              )?.searchStatusType || null,
        };
      })
    );
    setUniqueSearchesOfOrder(
      uniqBy(
        completedSearches.map((cs: any) => ({
          ...cs,
          selected: false,
          ...getCurrentIntegrationIds(cs),
        })),
        'searchTypeId'
      )
    );
  };
  const searchOrders = async (searchTerm: string, urlPart: string = 'simpleOrderSearch') => {
    const { data } = await axios.get(`/api/orders/${urlPart}`, {
      params: {
        searchTerm: searchTerm?.trim(),
        stateCode: 'NY',
      },
    });
    return data.map((order: any) => ({
      ...order,
      label: `HDS${order.id} - ${order.titleNumber}`,
      value: order.id,
    }));
  };

  const parseMsgFile = async (fieldsData: EmailFields) => {
    const subject = fieldsData.subject;
    if (!subject) return;
    const senderEmail = fieldsData.senderEmail;
    const orders = await searchOrders(subject, 'searchOrderByTitleNumberFromEmailSubject');
    if (orders.length === 1) {
      setOrderDetails(orders[0]);
      setSentFromEmail(senderEmail);
    } else if (orders.length > 1) {
      setOrderSearchResults(orders);
      setIsMenuOpen(true);
      setSentFromEmail(senderEmail);
    }
    setCcReceivers(fieldsData.ccEmails);
  };

  const getDefaultReceiver = (clientId: number, senderEmail: string) => {
    const abstractsIncorporatedClientId = 162;
    return clientId !== abstractsIncorporatedClientId &&
      !senderEmail?.toLowerCase().includes('closingusa') &&
      !senderEmail?.toLowerCase().includes('no-reply') &&
      !senderEmail?.toLowerCase().includes('noreply') &&
      !senderEmail?.toLowerCase().includes('exchange') &&
      !senderEmail?.toLowerCase().includes('notifications@thoroughbredtitleservices.com') &&
      senderEmail?.includes('@')
      ? senderEmail
      : '';
  };
  const setSelectedSearch = (searchId: number, propertyId: number) => {
    const searchWithSearchId = allSearchesOfOrder.find(s => s.id === searchId);
    const searchTypeId = searchWithSearchId.searchTypeId;
    const searchCode = searchWithSearchId.searchCode;
    const isAbstract = searchWithSearchId.searchCategory === 'Abstract';
    const isCurrentlySelected = searchWithSearchId.selected;
    const newSearchTypeObjects = produce(searchTypeObjects, draft => {
      const existingSearchTypeObject = draft.find(s => s.searchTypeId === searchTypeId);
      if (isCurrentlySelected) {
        if (!existingSearchTypeObject) {
          return;
        }
        if (existingSearchTypeObject.searchesToAdd.find(s => s.propertyId === propertyId)) {
          // property is currently part of search type object, must be removed
          if (existingSearchTypeObject.searchesToAdd.length == 1) {
            // search type object only exists for this property, remove search type object
            return draft.filter(o => o.searchTypeId !== searchTypeId);
          }
          // search type object exists for other properties too, remove this property from object
          existingSearchTypeObject.searchesToAdd = existingSearchTypeObject.searchesToAdd.filter(
            s => s.propertyId != propertyId
          );
        }
        return;
      }

      if (existingSearchTypeObject) {
        if (!existingSearchTypeObject.searchesToAdd.find(s => s.propertyId === propertyId)) {
          // object exists but does not contain this property, add property to object
          existingSearchTypeObject.searchesToAdd.push({
            propertyId,
            accutitleNumber: searchWithSearchId.accutitleNumber,
            riversideSearchId: searchWithSearchId.riversideSearchId,
          });
        }
      } else {
        const hasVendor = hasBulkVendorAssigneeForSearchType(isAbstract);
        const searchesToAdd = [
          {
            propertyId,
            accutitleNumber: searchWithSearchId.accutitleNumber,
            riversideSearchId: searchWithSearchId.riversideSearchId,
          },
        ];
        // object does not exist, create new object
        draft.push(
          createSearchTypeObject({
            searchTypeId,
            searchCode,
            searchesToAdd,
            isAbstract,
            hasVendor,
          })
        );
      }
    });
    setSearchTypeObjects(newSearchTypeObjects);
    const newSearches = produce(allSearchesOfOrder, draft => {
      const index = draft.findIndex(s => s.id === searchId);
      draft[index].selected = !draft[index].selected;
    });
    setAllSearchesOfOrder(newSearches);
    setPropertyId(propertyId);
  };
  const setSearchIntegrationId = (
    searchId: number,
    key: keyof AddedSearches,
    value: string,
    propertyIdOfSearch: number
  ) => {
    const newSearches = produce(allSearchesOfOrder, draft => {
      const index = draft.findIndex(s => s.id === searchId);
      draft[index][key] = value;
    });
    setAllSearchesOfOrder(newSearches);
    setPropertyId(propertyIdOfSearch);
    const searchInfo = newSearches.find(s => s.id === searchId);
    const isAbstract = searchInfo.searchCategory === 'Abstract';
    const newSearchTypeObjects = produce(searchTypeObjects, draft => {
      const existingSearchTypeObjectForSearchType = draft.find(
        s => s.searchTypeId === searchInfo.searchTypeId
      );
      if (existingSearchTypeObjectForSearchType) {
        // search type already exists
        var existingSearchTypeObjectForSearchTypeAndProperty = existingSearchTypeObjectForSearchType.searchesToAdd.find(
          s => s.propertyId === propertyIdOfSearch
        );
        if (existingSearchTypeObjectForSearchTypeAndProperty) {
          // already includes property
          (existingSearchTypeObjectForSearchTypeAndProperty as any)[key] = value;
        } else {
          // property needs to be added
          existingSearchTypeObjectForSearchType.searchesToAdd.push({ propertyId: propertyIdOfSearch });
          (existingSearchTypeObjectForSearchType.searchesToAdd.find(
            s => s.propertyId === propertyIdOfSearch
          ) as any)[key] = value;
        }
      } else {
        const hasVendor = hasBulkVendorAssigneeForSearchType(isAbstract);
        const searchesToAdd = [{ propertyId: propertyIdOfSearch }];
        // search type needs to be added
        draft.push(
          createSearchTypeObject({
            searchTypeId: searchInfo.searchTypeId,
            searchCode: searchInfo.searchCode,
            searchesToAdd,
            isAbstract,
            hasVendor,
          })
        );
        (draft
          .find(s => s.searchTypeId === searchInfo.searchTypeId)
          .searchesToAdd.find(s => s.propertyId === propertyIdOfSearch) as any)[key] = value;
      }
    });
    setSearchTypeObjects(newSearchTypeObjects);
  };
  const setSelectedSearches = (searchType: string, selected: boolean) => {
    const newSearchTypeObjects = produce(searchTypeObjects, draft => {
      const searchWithSearchCode = allSearchesOfOrder.find(s => s.searchCode === searchType);
      const searchTypeId = searchWithSearchCode.searchTypeId;
      const isAbstract = searchWithSearchCode.searchCategory === 'Abstract';
      if (selected) {
        const searchesToAddForSearchType = uniqBy(
          allSearchesOfOrder
            .filter(s => s.searchCode === searchType)
            .map(s => {
              return {
                propertyId: s.propertyId,
                accutitleNumber: s.accutitleNumber,
                riversideSearchId: s.riversideSearchId,
              };
            }),
          'propertyId'
        );
        const existingSearchTypeObject = draft.find(o => o.searchTypeId === searchTypeId);
        if (existingSearchTypeObject) {
          existingSearchTypeObject.searchesToAdd = searchesToAddForSearchType;
        } else {
          const hasVendor = hasBulkVendorAssigneeForSearchType(isAbstract);
          draft.push(
            createSearchTypeObject({
              searchTypeId,
              searchCode: searchType,
              searchesToAdd: searchesToAddForSearchType,
              isAbstract,
              hasVendor,
            })
          );
        }
      } else {
        return draft.filter(o => o.searchTypeId !== searchTypeId);
      }
    });
    setSearchTypeObjects(newSearchTypeObjects);
    const newSearches = produce(allSearchesOfOrder, draft => {
      const searchTypes = draft.filter(st => st.searchCode === searchType);
      for (let search of searchTypes) {
        const index = draft.findIndex(s => s.id === search.id);
        draft[index].selected = selected;
      }
    });
    setAllSearchesOfOrder(newSearches);
  };
  const addOrderDoc = async () => {
    var orderDocBody = {
      fileName: 'Added Contin.pdf',
      files: files,
      addNotes: false,
    };
    if (files.length > 0) {
      await axios.post(`/api/orders/uploadOrderDocument/${orderDetails.id}`, orderDocBody);
    }
  };

  const submit = async () => {
    if (searchTypeObjects.length === 0) {
      setErrorMessage('No Searches Selected');
      return;
    }

    var searchTypeObjectsToPost: SearchTypeObjectForSubmit[] = formatSearchTypeObjectsForSubmit();

    if (!searchTypeObjectsToPost.every(s => s.assigneeId)) {
      setErrorMessage('Each search must have an assignee');
      return;
    }

    var continReceivers = ccReceivers;
    if (continReceiver && !ccReceivers.includes(continReceiver)) {
      continReceivers.push(continReceiver);
    }
    const submitObj = {
      orderId: orderDetails.id,
      continReceivers,
      searchTypeObjects: searchTypeObjectsToPost,
    };

    setIsLoading(true);
    const response = await axios.post(`/api/contins/addContins/`, submitObj);
    handleResponse(response);

    resetStateFields();
  };

  const bulkEmailBody = React.useMemo(
    () =>
      buildContinEmailBody({
        dueBy: bulkDueBy,
        isPriority: bulkIsPriority,
        requestNotes: bulkRequestNotes,
      }),
    [bulkDueBy, bulkIsPriority, bulkRequestNotes]
  );

  const getEffectiveSearchTypeState = React.useCallback(
    (
      searchTypeObject: SearchTypeObject,
      { useBulkValues = false, useBulkAttachments = useBulkValues } = {}
    ): EffectiveSearchTypeState => {
      const bulkAssignee = searchTypeObject.isAbstract ? bulkAbstractAssignTo : bulkAssignTo;
      const hasRowAssignee = !!searchTypeObject.assigneeId;
      const assigneeId = hasRowAssignee ? searchTypeObject.assigneeId : bulkAssignee?.id;
      const assigneeIsEmployee = hasRowAssignee
        ? !!searchTypeObject.assigneeIsEmployee
        : !(bulkAssignee?.vendorId > 0);
      const hasVendorAssignee = !!assigneeId && !assigneeIsEmployee;
      const dueBy = useBulkValues ? bulkDueBy : searchTypeObject.dueBy ?? bulkDueBy;
      const isPriority = useBulkValues ? bulkIsPriority : searchTypeObject.isPriority ?? bulkIsPriority;
      const requestNotes = useBulkValues ? bulkRequestNotes : searchTypeObject.requestNotes ?? bulkRequestNotes;

      return {
        assigneeId,
        assigneeIsEmployee,
        hasVendorAssignee,
        dueBy,
        isPriority,
        requestNotes,
        emailBody: useBulkValues
          ? bulkEmailBody
          : buildContinEmailBody({
              dueBy,
              isPriority,
              requestNotes,
            }),
        vendorAttachments: !hasVendorAssignee
          ? []
          : useBulkAttachments
          ? bulkVendorEmailAttachments
          : searchTypeObject.vendorEmailAttachments ?? bulkVendorEmailAttachments,
      };
    },
    [
      bulkAbstractAssignTo,
      bulkAssignTo,
      bulkDueBy,
      bulkEmailBody,
      bulkIsPriority,
      bulkRequestNotes,
      bulkVendorEmailAttachments,
    ]
  );

  const buildEmailInfoForSubmit = (
    searchTypeObject: SearchTypeObject,
    effectiveState: EffectiveSearchTypeState
  ) => ({
      toAddresses:
        searchTypeObject.emailInfo.toAddresses?.length > 0
          ? searchTypeObject.emailInfo.toAddresses
          : bulkSelectedContacts,
      ccAddresses:
        searchTypeObject.emailInfo.ccAddresses?.length > 0
          ? searchTypeObject.emailInfo.ccAddresses
          : bulkSelectedCcEmails,
      bccAddresses:
        searchTypeObject.emailInfo.bccAddresses?.length > 0
          ? searchTypeObject.emailInfo.bccAddresses
          : bulkSelectedBccEmails,
      subject: searchTypeObject.emailInfo.subject?.length > 0 ? searchTypeObject.emailInfo.subject : bulkSubject,
      emailBody: effectiveState.emailBody,
      scheduleSend: searchTypeObject.emailInfo.scheduleSend
        ? searchTypeObject.emailInfo.scheduleSend
        : bulkScheduleSend,
      scheduleSendDateTime: searchTypeObject.emailInfo.scheduleSendDateTime ?? bulkScheduleSendDateTime,
    });

  const buildSearchTypeObjectForSubmit = (
    searchTypeObject: SearchTypeObject
  ): SearchTypeObjectForSubmit => {
    const effectiveState = getEffectiveSearchTypeState(searchTypeObject, {
      useBulkValues: assignInBulk,
      useBulkAttachments: assignInBulk,
    });

    return {
      searchTypeId: searchTypeObject.searchTypeId,
      searchCode: searchTypeObject.searchCode,
      searchesToAdd: searchTypeObject.searchesToAdd,
      assigneeId: effectiveState.assigneeId,
      assigneeIsEmployee: effectiveState.assigneeIsEmployee,
      additionalSendEmails: searchTypeObject.additionalSendEmails ?? bulkAdditionalSendEmails,
      isAbstract: searchTypeObject.isAbstract,
      dueBy: effectiveState.dueBy,
      isSixMonthContin: searchTypeObject.isSixMonthContin ?? bulkIsSixMonthContin,
      isPriority: effectiveState.isPriority,
      openNote: searchTypeObject.openNote,
      requestNotes: effectiveState.requestNotes,
      vendorEmailAttachments: effectiveState.hasVendorAssignee
        ? cloneFileUploads(effectiveState.vendorAttachments)
        : [],
      emailInfo: buildEmailInfoForSubmit(searchTypeObject, effectiveState),
      showEmailFields: searchTypeObject.showEmailFields,
      sendEmail: searchTypeObject.sendEmail ?? bulkSendEmail,
    };
  };

  const formatSearchTypeObjectsForSubmit = (): SearchTypeObjectForSubmit[] =>
    searchTypeObjects.map(buildSearchTypeObjectForSubmit);

  const handleResponse = (response: any) => {
    if (response.data.length > 0) {
      const failures = response.data.filter((d: any) => d.sendGridFail === true);
      const successes = response.data.filter((d: any) => d.sendGridSuccess === true);
      if (failures.length > 0) {
        failures.forEach((f: { file: any; fileName: any }) => convertToFileDownload(f.file, f.fileName));
        setSendGridError(true);
      } else if (successes.length > 0) {
        showSuccessToast(successes.find((s: any) => s.scheduled === true));
      } else {
        const filesToDownload = response.data.filter((d: any) => d.file && d.fileName);
        filesToDownload.forEach((f: any) => convertToFileDownload(f.file, f.fileName));
        showSavePopup();
      }
    } else {
      showSavePopup();
    }
  };

  const showSavePopup = () => {
    setSavePopup(true);
    setTimeout(() => {
      setSavePopup(false);
    }, 1500);
  };

  const showSuccessToast = (scheduled: boolean) => {
    toast(`Email ${scheduled ? 'Scheduled' : 'Sent'} Successfully`, {
      hideProgressBar: true,
      position: 'top-center',
      type: 'success',
      autoClose: 6000,
      theme: 'colored',
      style: { backgroundColor: '#4CAF50' },
    });
  };

  const resetStateFields = () => {
    addOrderDoc();
    setIsLoading(false);
    setOrderDetails({ id: null, titleNumber: '', clientId: null, integrationType: null });
    setSearchTypeObjects([]);
    setBulkAssignTo(null);
    setBulkAbstractAssignTo(null);
    setProperties([]);
    setBulkIsPriority(false);
    setBulkIsSixMonthContin(false);
    setCcReceivers([]);
    setFiles([]);
    setContinReceiver('');
    setUniqueSearchesOfOrder([]);
    setAllSearchesOfOrder([]);
    setPropertyId(null);
    setErrorMessage('');
    setBulkDueBy('');
    setClientType('');
    setFrontMessageId('');
    setBulkAdditionalSendEmails([]);
    setBulkRequestNotes('');
    setBulkVendorEmailAttachments([]);
    setSearchTypeObjects([]);
    setAssignInBulk(true);
    setBulkSelectedContacts([]);
    setBulkSelectedCcEmails([]);
    setBulkSelectedBccEmails([]);
    setBulkSubject('');
    setBulkScheduleSend(false);
    setBulkScheduleSendDateTime('');
    setBulkSendEmail(true);
  };

  const getRiversideOrderInfo = () => {
    if ([50, 439, 323, 321, 306, 1031].includes(orderDetails.clientId)) {
      setClientType('Riverside');
    }
  };

  const getAccutitleInfo = () => {
    if (orderDetails.integrationType === 3) {
      setClientType('Accutitle');
    }
  };

  const getAssignees = async () => {
    const usersPromise = axios.get('/api/users/forassignment');
    const vendorsPromise = axios.get('/api/vendors/getVendorsWithContacts');
    const [users, vendors] = await Promise.all([usersPromise, vendorsPromise]);

    setAssignees([
      { category: 'Employees', items: [...users.data] },
      { category: 'Vendors', items: [...vendors.data] },
    ]);
  };

  const handleBulkScheduleSendCheck = (checked: boolean) => {
    setBulkScheduleSend(checked);
    if (bulkScheduleSendDateTime === '') {
      const minDateTime = getCurrentDateTimeForDateTimePicker();
      setBulkScheduleSendDateTime(minDateTime);
      setScheduleSendMin(minDateTime);
    }
  };

  const handleBulkSendEmailCheck = (checked: boolean) => {
    setBulkSendEmail(checked);
    const newSearchTypeObjects = produce(searchTypeObjects, draft => {
      draft.forEach(d => (d.sendEmail = checked));
    });
    setSearchTypeObjects(newSearchTypeObjects);
  };

  useEffect(() => {
    if (orderDetails?.id) {
      getSearchesOfOrder();
    }
    getAssignees();
  }, [orderDetails]);
  return (
    <>
      <div style={{ fontWeight: 'bold', fontSize: 24, paddingBottom: 16 }}>Upload Contin</div>
      {orderDetails?.id && properties?.length > 0 && (
        <div style={{ height: 41, width: 39, position: 'absolute', top: 150, right: 500 }}>
          <RulesIcon
            padding={'4px 4px 0px 3px'}
            backgroundColor={'#f9d0d0'}
            municipalityIds={properties.map(p => p?.municipalityId)}
            subMunicipalityIds={properties.map(p => p?.subMunicipalityId)}
            countyIds={properties.map(p => p?.countyId)}
            locationTypeId={properties[0]?.locationTypeId}
            clientId={orderDetails.clientId}
          />
        </div>
      )}
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 4, fontSize: 14 }}>Front Message ID</label>
        <input
          type="text"
          value={frontMessageId}
          onChange={e => setFrontMessageId(e.target.value)}
          placeholder="Enter Front Message ID"
          onPaste={e => onPasteFrontMessageId(e.clipboardData.getData('Text'))}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              onPasteFrontMessageId(e.currentTarget.value);
            }
          }}
          style={{
            padding: '8px 12px',
            border: '1px solid #e5e5ea',
            borderRadius: 4,
            width: 376,
            fontSize: 14,
          }}
        />
      </div>
      <Dropzone onDrop={onDrop}>
        {({ getRootProps, getInputProps, isDragActive }) => {
          return (
            <DocumentOptions>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <div style={{ textAlign: 'center' }}>
                  {isDragActive ? <span>drop here</span> : <span>Drag and drop files</span>}

                  <div style={{ color: '#e5e5ea', paddingTop: 8, paddingBottom: 8 }}>Or</div>
                  <UploadButton>Select File</UploadButton>
                </div>
              </div>
            </DocumentOptions>
          );
        }}
      </Dropzone>
      {fetchingFrontFile ? (
        <div style={{ paddingTop: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
          <div className="ui active inline loader"></div>
          <div>Loading Front message...</div>
        </div>
      ) : (
        <>
          {files.length > 0 && <div style={{ paddingTop: 16 }}>File Uploaded to order: </div>}
          {files.map((file: any, index: any) => {
            return (
              <div key={file.fileName} style={{ marginLeft: '-200px' }}>
                <ImportedFileTag
                  fileNameToDisplay={file.actualFileName || file.fileName}
                  onRemoveClick={() => onRemoveFileClick(index)}
                  changeCustomFileName={changeCustomFileName(index)}
                />
              </div>
            );
          })}
        </>
      )}
      <div style={{ display: 'flex' }}>
        <div style={{ flexDirection: 'column', marginRight: 16, marginTop: 16 }}>
          <span style={{ marginBottom: 8, display: 'inline-block' }}>File Number:</span>
          <AsyncSelect
            value={
              orderDetails?.id
                ? { value: orderDetails?.id, label: `HDS${orderDetails?.id} - ${orderDetails?.titleNumber}` }
                : null
            }
            defaultOptions={orderSearchResults}
            menuIsOpen={isMenuOpen}
            loadOptions={searchTerm => searchOrders(searchTerm)}
            styles={customStyles}
            isClearable
            placeholder="Start Typing..."
            onChange={(e: any) => {
              onSelectOrder(e);
            }}
            onMenuOpen={() => setIsMenuOpen(true)}
            onMenuClose={() => setIsMenuOpen(false)}
            onInputChange={(_inputValue, actionMeta) => {
              if (actionMeta.action === 'input-change') {
                setSentFromEmail('');
                setCcReceivers([]);
              }
            }}
          />
        </div>
        {properties.length > 0 && (
          <>
            <TextField
              value={continReceiver}
              onChange={e => setContinReceiver(e.target.value)}
              label="Contin Receiver:"
              styles={{ marginTop: 16 }}
              width={'295px'}
            />
            <span
              style={{ display: 'flex', flexDirection: 'column', marginTop: 16, marginLeft: 16, width: 475 }}
            >
              <span style={{ display: 'inline-block', marginBottom: 8 }}>CC Emails:</span>
              <Multiselect
                value={ccReceivers}
                data={[]}
                onChange={editedCcReceivers => setCcReceivers(editedCcReceivers)}
                onCreate={ccReceiver => setCcReceivers([...ccReceivers, ccReceiver])}
                allowCreate="onFilter"
                valueField="id"
                textField="name"
                messages={{ emptyList: '', createOption: option => `Add "${option.searchTerm}"` }}
              />
            </span>
          </>
        )}
      </div>
      <PropertiesAndSearchesContin
        properties={properties}
        searches={allSearchesOfOrder}
        uniqueSearchesOfOrder={uniqueSearchesOfOrder}
        setSelectedSearch={setSelectedSearch}
        setSelectedSearches={setSelectedSearches}
        clientType={clientType}
        setSearchIntegrationId={setSearchIntegrationId}
        reactivateProperty={reactivateProperty}
      />
      {properties.length > 0 && isSearchSelected && (
        <>
          <Checkbox
            style={{ marginTop: 20 }}
            label="Assign searches in bulk"
            checked={assignInBulk}
            onChange={(e, { checked }) => setAssignInBulk(checked)}
          />
          {assignInBulk ? (
            <BulkSearchesInfo
              bulkDueBy={bulkDueBy}
              setBulkDueBy={setBulkDueBy}
              assignees={assignees}
              setBulkAssignTo={setBulkAssignTo}
              isAbstractSearchSelected={isAbstractSearchSelected}
              setBulkAbstractAssignTo={setBulkAbstractAssignTo}
              abstractDefaultAssignee={abstractDefaultAssignee}
              bulkAdditionalSendEmails={bulkAdditionalSendEmails}
              setBulkAdditionalSendEmails={setBulkAdditionalSendEmails}
              bulkIsPriority={bulkIsPriority}
              setBulkIsPriority={setBulkIsPriority}
              bulkIsSixMonthContin={bulkIsSixMonthContin}
              setBulkIsSixMonthContin={setBulkIsSixMonthContin}
              bulkAssignTo={bulkAssignTo}
              bulkAbstractAssignTo={bulkAbstractAssignTo}
              bulkRequestNotes={bulkRequestNotes}
              setBulkRequestNotes={setBulkRequestNotes}
              bulkScheduleSendDateTime={bulkScheduleSendDateTime}
              setBulkScheduleSendDateTime={setBulkScheduleSendDateTime}
              handleBulkScheduleSendCheck={handleBulkScheduleSendCheck}
              bulkSubject={bulkSubject}
              bulkEmailBody={bulkEmailBody}
              bulkScheduleSend={bulkScheduleSend}
              scheduleSendMin={scheduleSendMin}
              setBulkSubject={setBulkSubject}
              bulkSelectedContacts={bulkSelectedContacts}
              bulkContactsList={bulkDefaultContacts}
              setBulkSelectedContacts={setBulkSelectedContacts}
              bulkSelectedCcEmails={bulkSelectedCcEmails}
              setBulkSelectedCcEmails={setBulkSelectedCcEmails}
              bulkSelectedBccEmails={bulkSelectedBccEmails}
              setBulkSelectedBccEmails={setBulkSelectedBccEmails}
              bulkSendEmail={bulkSendEmail}
              setBulkSendEmail={handleBulkSendEmailCheck}
              bulkVendorEmailAttachments={bulkVendorEmailAttachments}
              setBulkVendorEmailAttachments={applyBulkVendorEmailAttachments}
            />
          ) : (
            <SearchInfoBySearchType
              searchTypeObjects={searchTypeObjects}
              setSearchTypeObjects={setSearchTypeObjects}
              bulkAbstractAssignTo={bulkAbstractAssignTo}
              bulkAssignTo={bulkAssignTo}
              assignees={assignees}
              bulkAdditionalSendEmails={bulkAdditionalSendEmails}
              bulkRequestNotes={bulkRequestNotes}
              bulkDueBy={bulkDueBy}
              bulkIsPriority={bulkIsPriority}
              bulkIsSixMonthContin={bulkIsSixMonthContin}
              scheduleSendMin={scheduleSendMin}
              setScheduleSendMin={setScheduleSendMin}
              bulkSendEmail={bulkSendEmail}
              setBulkSendEmail={setBulkSendEmail}
              vendorEmailsById={vendorEmailsById}
              fetchVendorEmail={fetchVendorEmail}
              getEffectiveSearchTypeState={getEffectiveSearchTypeState}
            />
          )}
        </>
      )}
      {showConflictingAbstractAssigneesModal && (
        <ConfirmActionModal
          openState={showConflictingAbstractAssigneesModal}
          onClose={handleModalClose}
          header="Conflicting abstract assignees"
          info={conflictingAbstractAssigneesString}
          buttonText="Close"
          actionFunction={handleModalClose}
          headerSymbol=" "
          hideSecondaryButton={true}
          height={400}
        />
      )}
      {sendGridError && (
        <SendGridErrorModal sendGridError={sendGridError} setSendGridError={setSendGridError} />
      )}
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginRight: 60,
          marginTop: 30,
          position: 'relative',
        }}
      >
        {selectedAssignOnlySearchCodes?.length > 0 && (
          <div
            style={{ marginRight: 20, border: 'solid grey', borderRadius: 3, padding: '5px 10px 5px 10px' }}
          >
            New contins will <b>NOT</b> be created for:
            <p>{selectedAssignOnlySearchCodes.map((s, index) => `${index > 0 ? ',' : ''} ${s}`)}</p>
          </div>
        )}
        {errorMessage && (
          <div style={{ color: '#ff5252', position: 'absolute', right: 0, top: -20 }}>{errorMessage}</div>
        )}
        <Button onClick={submit} loadingStatus={isLoading}>
          Submit
        </Button>
        {savePopup && (
          <div
            style={{
              color: '#fff',
              fontWeight: 'bold',
              position: 'absolute',
              bottom: -40,
              right: 50,
              backgroundColor: '#333',
              padding: 8,
              borderRadius: 4,
            }}
          >
            Saved!
          </div>
        )}
      </div>
    </>
  );
}
